import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const AnonymousModalPerk = styled.div<React.CSSProperties>`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: ${22 * Screen.widthRatio}px;
`;

export default AnonymousModalPerk;
